import {Component, OnInit, Input} from 'ng-metadata/core';
import {ProgressBarService} from './progressBar.service';
import {DateUtils} from '../../../../nddUtils/dateUtils.service';

const dateFormat = require('dateformat');

@Component({
    selector: 'prm-progress-bar',
    templateUrl: 'components/search/fullView/ngrs/progressBar/progress-bar.html',
})

export class PrmProgressBar implements OnInit{

    @Input() status: String;
    @Input() requestid: String;
    @Input() format: String;
    @Input() dates: Object;
    @Input() isDownloadable: boolean;
    @Input() isViewable: boolean;

    private checkedBarWidth: String;

    private requested: Object = {};
    private inProcess: Object;
    private shipped: Object;
    private received: Object;
    private sent: Object;

    private isdigitalrequest : boolean;

    constructor(private progressBarService: ProgressBarService,
                private dateUtils : DateUtils
        ) {                     
    }

    ngOnInit() {
        this.requested = {checked:false, label:"REQUESTED", date: ""};
        this.inProcess = {checked:false, label:"IN_PROCESS_BY_LENDER", date: ""};
        this.shipped = {checked:false, label:"SHIPPED", date: ""};
        this.received = {checked:false, label:"RECEIVED", date: ""};
        this.sent = {checked:false, label:"SENT", date: ""};

        if(this.format === "Digital" || this.status === "SENT"){
            this.isdigitalrequest = true;
        }else{
            this.isdigitalrequest = false;
        }
        this.updateStatusConfig(this.status);
        this.setRequestDates(); 
    }

    public setRequestDates(){
        if(this.isdigitalrequest === true){
            if(this.dates.requestedDate != ""){
                this.requested.date = this.dateUtils.convertIlsDateStringToPrimoDateString(this.dates.requestedDate);
            }
            if(this.dates.inProcessDate != ""){
                this.inProcess.date = this.dateUtils.convertIlsDateStringToPrimoDateString(this.dates.inProcessDate);
            }
            if(this.dates.shippedDate != ""){
                this.shipped.date = this.dateUtils.convertIlsDateStringToPrimoDateString(this.dates.shippedDate);
            }
            if(this.dates.sentDate != ""){
                this.sent.date = this.dateUtils.convertIlsDateStringToPrimoDateString(this.dates.sentDate);
            }
        }else{
            if(this.dates.requestedDate != ""){
                this.requested.date = this.dateUtils.convertIlsDateStringToPrimoDateString(this.dates.requestedDate);
            }
            if(this.dates.inProcessDate != ""){
                this.inProcess.date = this.dateUtils.convertIlsDateStringToPrimoDateString(this.dates.inProcessDate);
            }
            if(this.dates.shippedDate != ""){
                this.shipped.date = this.dateUtils.convertIlsDateStringToPrimoDateString(this.dates.shippedDate);
            }
            if(this.dates.receivedDate != ""){
                this.received.date = this.dateUtils.convertIlsDateStringToPrimoDateString(this.dates.receivedDate);
            }
        }
    }

    public updateStatusConfig(status){
        if(status === "REQUESTED"){
            this.requested.checked = true;
        }
        else if(status === "IN_PROCESS_BY_LENDER"){
            if (this.isDownloadable == true || this.isViewable == true){
                status = "SENT"
                this.requested.checked = true;
                this.inProcess.checked = true;
                this.sent.checked = true;
            }
            else {
                this.requested.checked = true;
                this.inProcess.checked = true;
            }
        }
        else if(status === "SHIPPED"){
            this.requested.checked = true;
            this.inProcess.checked = true;
            this.shipped.checked = true;
        }
        else if(status === "RECEIVED" || status === "CHECKED_OUT"){
            this.requested.checked = true;
            this.inProcess.checked = true;
            this.shipped.checked = true;
            this.received.checked = true;
        }
        else if(status === "SENT"){
            this.requested.checked = true;
            this.inProcess.checked = true;
            this.sent.checked = true;
            if(this.isdigitalrequest){
                this.shipped.checked = true;
            }
        }
    }

    public isDigitalRequest(){
        return this.isdigitalrequest;
    }
    
}



// WEBPACK FOOTER //
// ./src/main/webapp/components/search/fullView/ngrs/progressBar/progressBar.directive.ts